import React, { useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import { NavLink } from "react-router-dom";
import SnackBar from '../snackbar/snackbar';
import AgreementDialog from '../agreement-popup/agreement';
import adminApi from '../../../assets/constants/AdminRafservice.Instance';
import mainLogo from '../../../assets/images/Invent_logo_White.png';
import clsx from 'clsx';
import UserPool from '../../../assets/constants/user-pool';
import { 
  CognitoUserPool, 
  CognitoUser, 
  AuthenticationDetails, 
  CognitoUserAttribute 
} from 'amazon-cognito-identity-js';
import Header from '../../home/header/header';
import { connect } from 'react-redux';
import { signIn, signOut, permssionAssign } from '../../../store/actions';
import history from '../../../history';
import ForgotPassword from '../forgot-password/forgot-password';
import { Auth } from 'aws-amplify';
import CircularProgress from '@material-ui/core/CircularProgress';
import AccessKeys from '../../../assets/constants/AccessKeyAPI.Instance';
import { getSecretManager } from '../../../Pages/config/SecretManager';
import { LogFileUploadToS3 } from '../../../assets/constants/LogFileUploadToS3';

// Enhanced logging utility for login operations
const logLoginEvent = (message, data = {}) => {
  const timestamp = new Date().toISOString();
  
  // Create a properly formatted log entry with safe JSON serialization
  let dataString = '';
  if (Object.keys(data).length > 0) {
    try {
      dataString = ` | Data: ${JSON.stringify(data, (key, value) => {
        // Handle circular references and functions
        if (typeof value === 'function') return '[Function]';
        if (typeof value === 'object' && value !== null) {
          if (value.constructor && value.constructor.name !== 'Object' && value.constructor.name !== 'Array') {
            return `[${value.constructor.name}]`;
          }
        }
        return value;
      }, 2)}`;
    } catch (error) {
      dataString = ` | Data: [Object serialization failed: ${error.message}]`;
    }
  }
  
  const formattedLogEntry = `[${timestamp}] [LOGIN] ${message}${dataString}`;
  
  // Log the properly formatted entry to console
  console.log(formattedLogEntry);
  
  // Store log in a global array for S3 upload
  if (window.loginLogs) {
    window.loginLogs.push(formattedLogEntry);
  } else {
    window.loginLogs = [formattedLogEntry];
  }
};

// Helper function to upload login logs to S3
const uploadLoginLogsToS3 = async (logSuffix = "LOGIN_SUCCESS_Log") => {
  try {
    logLoginEvent("Preparing to upload login logs to S3", { logSuffix });
    
    // Check if we have a valid token first
    const token = localStorage.getItem("Token") || localStorage.getItem("accessToken");
    if (!token) {
      logLoginEvent("No token available for /keys API call, skipping S3 upload");
      return;
    }
    
    logLoginEvent("Token found, calling /keys API for S3 upload", { 
      hasToken: !!token, 
      tokenLength: token.length 
    });
    
    const res = await AccessKeys.get("/keys");
    
    if (res && res.data && res.data.access_key && res.data.secret_key) {
      logLoginEvent("Successfully fetched access keys from API");
      
      const secrets = await getSecretManager(
        res.data.access_key,
        res.data.secret_key,
        res.data.session_token,
        false
      );
      
      logLoginEvent("Successfully fetched secrets from getSecretManager");
      const BUCKET = process.env.REACT_APP_LOG_BUCKET;
      
      LogFileUploadToS3(
        window.loginLogs || [], // Upload login-specific logs
        secrets.s3AccessKey,
        secrets.s3SecretKey,
        BUCKET,
        logSuffix
      );
      
      logLoginEvent("Login logs uploaded to S3 successfully", { bucket: BUCKET, suffix: logSuffix });
      
    } else {
      logLoginEvent("AccessKeys API did not return expected keys", { 
        response: res ? res.data : "no response",
        hasData: !!(res && res.data),
        hasAccessKey: !!(res && res.data && res.data.access_key),
        hasSecretKey: !!(res && res.data && res.data.secret_key)
      });
    }
  } catch (error) {
    logLoginEvent("Error during login logs S3 upload process", { 
      error: error.message,
      stack: error.stack
    });
    console.error("Login logs S3 upload error:", error);
  }
};

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://www.inventhealth.com/">
        www.inventhealth.com
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(0),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: 'white',
    padding: '20px',
    borderRadius: '10px',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  textField: {
    width: '100%',
  },
  verificationContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  resendButton: {
    marginTop: theme.spacing(1),
    textTransform: 'none',
  },
  messageBox: {
    padding: theme.spacing(1),
    marginBottom: theme.spacing(2),
    borderRadius: '4px',
    backgroundColor: '#f5f5f5',
  }
}));

// Cognito configuration from new file
const poolData = {
  UserPoolId: process.env.REACT_APP_USER_POOL_ID,
  ClientId: process.env.REACT_APP_CLIENT_ID,
};

const userPool = new CognitoUserPool(poolData);

const SignIn = (props) => {
const [snackBarStatus, setSnackBarStatus] = useState({ open: false, message: '' });
const [loginSuccess, setLoginSuccess] = useState(false);
const [loginShow, setLoginShow] = useState(true);
const [showForgot, setShowForgot] = useState(false);
const [checkBoxValue, setCheckBoxValue] = useState(true);
const [isLoading, setIsLoading] = useState(false);
const [values, setValues] = useState({
  password: '',
  showPassword: false,
});

// State for MFA
const [email, setEmail] = useState('');
const [code, setCode] = useState('');
const [message, setMessage] = useState('');
const [challengeType, setChallengeType] = useState('');
const [cognitoUser, setCognitoUser] = useState(null);
const [isResending, setIsResending] = useState(false);
const [showMFAVerification, setShowMFAVerification] = useState(false);

const classes = useStyles();

React.useEffect(() => {
  document.getElementsByTagName("body")[0].classList.add("normal-layout-container");
  document.getElementsByTagName("body")[0].classList.remove("awe-layout-container");
}, []);

const handleChange = (prop) => (event) => {
  setValues({ ...values, [prop]: event.target.value });
};

const handleClickShowPassword = () => {
  setValues({ ...values, showPassword: !values.showPassword });
};

const handleMouseDownPassword = (event) => {
  event.preventDefault();
};

const handleEmailChange = (event) => {
  setEmail(event.target.value);
};

const handleCodeChange = (event) => {
  setCode(event.target.value);
};

async function signUpWithAuthAmplify(userEmail, password) {
  try {
    await Auth.signUp({
      username: userEmail,
      password: password,
    });
  } catch (error) {
    console.log(error);
  }
}

const signUp = (email, password) => {
  UserPool.signUp(email, password, [], null, (err, data) => {
    if (err) {
      setSnackBarStatus({ open: true, message: `Unable to create user ${err.message}` });
    } else {
      setSnackBarStatus({ open: true, message: "User created successfully. Please contact administrator to confirm." });
      let user = {
        user_id: data.userSub,
        user_name: email,
        email: email,
        password: password,
        status: true
      };
      signUpWithAuthAmplify(email, password);
      addUserToControlDb(user);
    }
  });
};
  
const addUserToControlDb = (data) => {
  adminApi.post('/auth/signup', data)
    .then(res => {
      // Handle successful response if needed
    })
    .catch(err => {
      // Handle error if needed
      console.error("Error adding user to control DB:", err);
    });
};

const getSession = async () => {
  return await new Promise((resolve, reject) => {
    const user = UserPool.getCurrentUser();
    if (user) {
      user.getSession((err, session) => {
        if (err) {
          reject(err);
        } else {
          resolve(session);
        }
      });
    } else {
      reject(new Error("No current user"));
    }
  });
};

async function signInWithAuth(username, password) {
  try {
    await Auth.signIn(username, password);
  } catch (error) {
    console.log('Error signing in:', error);
  }
}

const getAuthenticated = async (user, authDetails, loginData) => {
  return new Promise((resolve, reject) => {
    user.authenticateUser(authDetails, {
      onSuccess: (data) => {
        // Check if MFA is required for this user
        const isMfaRequired = true; // Set this based on your business logic

        if (!isMfaRequired) {
          // If MFA is not required, proceed with normal login
          setSnackBarStatus({ open: true, message: "Login is successful..." });
          setLoginSuccess(true);
          props.signIn({ userEmail: email, data: data });
          localStorage.setItem('user', JSON.stringify({ userEmail: email, data: data }));

          // Amplify Auth signin api call
          signInWithAuth(email, loginData.password);

          const accessToken = data.getAccessToken().getJwtToken();
          localStorage.setItem("Token", JSON.stringify(accessToken));
          
          logLoginEvent("Username/Password authentication tokens stored in localStorage", {
            userEmail: email,
            hasAccessToken: !!accessToken,
            tokenLength: accessToken ? accessToken.length : 0,
            authMethod: "Username/Password"
          });

          // Get user permissions
          adminApi.post('/auth/signin', { email: email, password: loginData.password })
            .then(res => {
              logLoginEvent("User permissions API call successful", {
                hasUserDetails: !!res.data.userDetails,
                hasPermissions: !!res.data.permissions,
                permissionsCount: res.data.permissions ? res.data.permissions.length : 0
              });
              
              localStorage.setItem('controlUser', JSON.stringify(res.data.userDetails));
              localStorage.setItem('controlPermissions', JSON.stringify(res.data.permissions));
              localStorage.setItem('controlAccessToken', res.data.accessToken);
              props.permssionAssign(res.data.permissions);
              
              logLoginEvent("User permissions and control data stored in localStorage");
              
              // Upload login logs to S3 after all data is stored
              setTimeout(() => {
                logLoginEvent("Initiating S3 upload for successful username/password login");
                uploadLoginLogsToS3("USERNAME_PASSWORD_SUCCESS_Log");
              }, 500); // Small delay to ensure all operations complete
            })
            .catch(err => {
              logLoginEvent("Error getting user permissions", {
                error: err.message || err.toString(),
                status: err.response ? err.response.status : 'unknown'
              });
              console.error("Error getting user permissions:", err);
              
              // Upload error logs to S3
              setTimeout(() => {
                uploadLoginLogsToS3("USERNAME_PASSWORD_ERROR_Log");
              }, 500);
            });
            
          history.push("/home");
        } else {
          // Password is correct, now just let MFA continue
          resolve(data);
        }
      },
      onFailure: (err) => {
        console.error("onFailure:", err);
        setSnackBarStatus({ open: true, message: `Unable to authenticate user! ${err.message}` });
        reject(err);
      },
      newPasswordRequired: (data) => {
        setSnackBarStatus({ open: true, message: "New Password is required" });
        resolve(data);
      }
    });
  });
};


const initiateAuth = (userEmail, password) => {

  adminApi.post('/auth/signin', { email: userEmail, password: password })
    .then(res => {
      console.log("Validation response:", res.data);
      if (res.data) {
        const authenticationData = {
          Username: userEmail,
          Password: password,
        };
        
        const authenticationDetails = new AuthenticationDetails(authenticationData);
        
        const userData = {
          Username: userEmail,
          Pool: userPool,
        };
        
        const cognitoUser = new CognitoUser(userData);
        setCognitoUser(cognitoUser);
        
        cognitoUser.initiateAuth(authenticationDetails, {
          onSuccess: (result) => {
            setMessage('Authentication successful!');
            handleLoginSuccess(userEmail, result);
          },
          onFailure: (err) => {
            setIsLoading(false);
            setMessage(`Authentication failed: ${err.message}`);
            setSnackBarStatus({ open: true, message: `Unable to authenticate user! ${err.message}` });
          },
          customChallenge: (challengeParameters) => {
            const trigger = challengeParameters.trigger;
            setChallengeType(trigger);
            
            if (trigger === 'password') {
              cognitoUser.sendCustomChallengeAnswer(password, {
                onSuccess: (result) => {
                  handleLoginSuccess(userEmail, result);
                },
                onFailure: (err) => {
                  setIsLoading(false);
                  setMessage(`Authentication failed: ${err.message}`);
                  setSnackBarStatus({ open: true, message: `Unable to authenticate user! ${err.message}` });
                },
                customChallenge: (challengeParameters) => {
                  const trigger = challengeParameters.trigger;
                  setChallengeType(trigger);
                  
                  if (trigger === 'email') {
                    setIsLoading(false);
                    setMessage('Please enter the verification code sent to your email.');
                    setShowMFAVerification(true);
                  }
                }
              });
            } else if (trigger === 'email') {
              setIsLoading(false);
              setMessage('Please enter the verification code sent to your email.');
              setShowMFAVerification(true);
            }
          }
        });
      } else {
        setIsLoading(false);
        setMessage('Invalid email or password.');
        setSnackBarStatus({ open: true, message: 'Invalid email or password. Please try again.' });
      }
    })
    .catch(err => {
      setIsLoading(false);
      setMessage(`Validation error: ${err.message}`);
      setSnackBarStatus({ open: true, message: `Unable to validate credentials. Please try again later.` });
    });
};

const submitEmailCode = (e) => {
  e.preventDefault();
  
  if (!cognitoUser) {
    setMessage('Authentication session expired. Please try again.');
    setSnackBarStatus({ open: true, message: 'Authentication session expired. Please try again.' });
    return;
  }
  
  cognitoUser.sendCustomChallengeAnswer(code, {
    onSuccess: (result) => {
      setMessage('Authentication successful!');
      handleLoginSuccess(email, result);
    },
    onFailure: (err) => {
      setMessage(`Verification failed: ${err.message}`);
      setSnackBarStatus({ open: true, message: `Verification failed: ${err.message}` });
    },
    customChallenge: (challengeParameters) => {
      const trigger = challengeParameters.trigger;
      setChallengeType(trigger);
      setMessage('Additional verification required.');
    }
  });
};

const resendOTP = () => {
  if (!cognitoUser) {
    setMessage('Authentication session expired. Please try again.');
    setSnackBarStatus({ open: true, message: 'Authentication session expired. Please try again.' });
    return;
  }

  setIsResending(true);
  setMessage('Sending a new verification code...');
  
  const authenticationData = {
    Username: email,
    Password: values.password,
  };
  
  const authenticationDetails = new AuthenticationDetails(authenticationData);
  
  cognitoUser.initiateAuth(authenticationDetails, {
    onSuccess: (result) => {
      // This shouldn't happen directly as we expect the challenge flow
      setIsResending(false);
    },
    onFailure: (err) => {
      setMessage(`Failed to resend code: ${err.message}`);
      setSnackBarStatus({ open: true, message: `Failed to resend code: ${err.message}` });
      setIsResending(false);
    },
    customChallenge: (challengeParameters) => {
      const trigger = challengeParameters.trigger;
      
      if (trigger === 'password') {
        // Silently answer the password challenge to move to the email challenge
        cognitoUser.sendCustomChallengeAnswer(values.password, {
          onSuccess: (result) => {
            setIsResending(false);
          },
          onFailure: (err) => {
            setMessage(`Failed to resend code: ${err.message}`);
            setSnackBarStatus({ open: true, message: `Failed to resend code: ${err.message}` });
            setIsResending(false);
          },
          customChallenge: (challengeParameters) => {
            const newTrigger = challengeParameters.trigger;
            
            if (newTrigger === 'email') {
              setMessage('A new verification code has been sent to your email.');
              setSnackBarStatus({ open: true, message: 'A new verification code has been sent to your email.' });
              setIsResending(false);
              setChallengeType('email');
            }
          }
        });
      } else if (trigger === 'email') {
        setMessage('A new verification code has been sent to your email.');
        setSnackBarStatus({ open: true, message: 'A new verification code has been sent to your email.' });
        setIsResending(false);
        setChallengeType('email');
      }
    }
  });
};

// Success handling function
// Updated success handling function
const handleLoginSuccess = (userEmail, result) => {
  logLoginEvent("MFA login success handler initiated", {
    userEmail,
    hasResult: !!result
  });
  
  setShowMFAVerification(false);
  setLoginSuccess(true);
  setSnackBarStatus({ open: true, message: "Login is successful..." });
  
  // Store tokens
  console.log("Login result:", result);
  const accessToken = result.getAccessToken().getJwtToken();
  const idToken = result.getIdToken().getJwtToken();
  const refreshToken = result.getRefreshToken().getToken();
  
  localStorage.setItem('accessToken', accessToken);
  localStorage.setItem('idToken', idToken);
  localStorage.setItem('refreshToken', refreshToken);
  localStorage.setItem("Token", (accessToken));
  
  logLoginEvent("MFA authentication tokens stored in localStorage", {
    userEmail,
    hasAccessToken: !!accessToken,
    hasIdToken: !!idToken,
    hasRefreshToken: !!refreshToken,
    tokenLength: accessToken ? accessToken.length : 0,
    authMethod: "Username/Password with MFA"
  });
  
  // Set user in Redux store
  props.signIn({ userEmail: userEmail, data: result });
  localStorage.setItem('user', JSON.stringify({ userEmail: userEmail, data: result }));
  
  // Amplify Auth signin
  signInWithAuth(userEmail, values.password);
  
  // Get user permissions from temporary storage
  const tempUser = localStorage.getItem('tempControlUser');
  const tempPermissions = localStorage.getItem('tempControlPermissions');
  const tempAccessToken = localStorage.getItem('tempControlAccessToken');
  
  logLoginEvent("Processing temporary user data from localStorage", {
    hasTempUser: !!tempUser,
    hasTempPermissions: !!tempPermissions,
    hasTempAccessToken: !!tempAccessToken
  });
  
  if (tempUser && tempPermissions && tempAccessToken) {
    localStorage.setItem('controlUser', tempUser);
    localStorage.setItem('controlPermissions', tempPermissions);
    localStorage.setItem('controlAccessToken', tempAccessToken);
    props.permssionAssign(JSON.parse(tempPermissions));
    
    logLoginEvent("User permissions and control data transferred from temporary storage", {
      permissionsCount: JSON.parse(tempPermissions).length
    });
    
    // Clean up temporary storage
    localStorage.removeItem('tempControlUser');
    localStorage.removeItem('tempControlPermissions');
    localStorage.removeItem('tempControlAccessToken');
    
    logLoginEvent("Temporary storage cleaned up successfully");
    
    // Upload login logs to S3 after all data is stored
    setTimeout(() => {
      logLoginEvent("Initiating S3 upload for successful MFA login");
      uploadLoginLogsToS3("MFA_SUCCESS_Log");
    }, 500); // Small delay to ensure all operations complete
  } else {
    logLoginEvent("Missing temporary user data, login may be incomplete", {
      hasTempUser: !!tempUser,
      hasTempPermissions: !!tempPermissions,
      hasTempAccessToken: !!tempAccessToken
    });
    
    // Still upload logs even if permissions are missing
    setTimeout(() => {
      uploadLoginLogsToS3("MFA_INCOMPLETE_Log");
    }, 500);
  }

  // Redirect to home page
  history.push("/home");
};
// Modified login function to use traditional authentication first
// Login function with validation before MFA
// Login function with validation before MFA
const login = async (event) => {
  event.preventDefault();
  const userEmail = event.target[0].value;
  const password = event.target[2].value;
  const termAndCondition = event.target[5].checked;

  logLoginEvent("Login process initiated", {
    userEmail,
    hasPassword: !!password,
    passwordLength: password ? password.length : 0,
    termsAccepted: termAndCondition,
    authMethod: "Username/Password"
  });

  setEmail(userEmail);
  setValues({ ...values, password: password });

  // Basic input validation
  if (userEmail === '' || password === '') {
    logLoginEvent("Login validation failed - missing email or password", {
      hasEmail: !!userEmail,
      hasPassword: !!password
    });
    setSnackBarStatus({ open: true, message: 'Email and password are required!' });
    return;
  }
  
  if (termAndCondition === false) {
    logLoginEvent("Login validation failed - terms and conditions not accepted");
    setSnackBarStatus({ open: true, message: `Please select terms & condition!` });
    return;
  }

  if (loginShow) {
    logLoginEvent("Starting login flow - validating credentials");
    setIsLoading(true);
    
    // Validate credentials before starting MFA flow
    adminApi.post('/auth/signin', { email: userEmail, password: password })
      .then(res => {
        logLoginEvent("Credential validation successful", {
          hasUserDetails: !!res.data.userDetails,
          hasPermissions: !!res.data.permissions,
          hasAccessToken: !!res.data.accessToken,
          permissionsCount: res.data.permissions ? res.data.permissions.length : 0
        });
        
        // If we get a successful response, credentials are valid
        // Now proceed with MFA flow
        logLoginEvent("Proceeding to MFA authentication flow");
        initiateAuth(userEmail, password);
        
        // Store user details for later use after MFA is complete
        localStorage.setItem('tempControlUser', JSON.stringify(res.data.userDetails));
        localStorage.setItem('tempControlPermissions', JSON.stringify(res.data.permissions));
        localStorage.setItem('tempControlAccessToken', res.data.accessToken);
        
        logLoginEvent("Temporary user data stored for MFA completion", {
          userDetailsKeys: res.data.userDetails ? Object.keys(res.data.userDetails) : [],
          permissionsCount: res.data.permissions ? res.data.permissions.length : 0
        });
      })
      .catch(err => {
        logLoginEvent("Credential validation failed", {
          error: err.message || err.toString(),
          status: err.response ? err.response.status : 'unknown',
          userEmail
        });
        
        // If credentials are invalid, show error and don't proceed to MFA
        setIsLoading(false);
        setSnackBarStatus({ 
          open: true, 
          message: err.response?.data?.message || 'Invalid email or password. Please try again.' 
        });
        
        // Upload error logs to S3
        setTimeout(() => {
          uploadLoginLogsToS3("LOGIN_VALIDATION_ERROR_Log");
        }, 500);
      });
  } else {
    logLoginEvent("Switching to sign-up flow");
    // Use the sign-up flow
    signUp(userEmail, password);
  }
};

const handleSSOSignIn = () => {
  const base = process.env.REACT_APP_SSO_URL_BASE || '';
  const path = process.env.REACT_APP_SSO_URL_PATH || '';
  const params = process.env.REACT_APP_SSO_URL_PARAMS || '';
  const ssoUrl = `${base}${path}${params}`;
  if (ssoUrl) {
    window.location.href = ssoUrl;
  }
};

const renderButtons = () => {
  return (
    <>
      <Button
        type="submit"
        fullWidth
        variant="contained"
        color="primary"
        className={classes.submit}
        disabled={isLoading}
      >
        {loginShow ? 'Sign In ' : 'Sign Up'}
        {isLoading && (
          <CircularProgress 
            size={20} 
            style={{ 
              marginLeft: 10,
              color: 'white'
            }}
          />
        )}
      </Button>
      {/* SSO Button: Only show on login, not sign up or MFA */}
      {loginShow && !showForgot && !showMFAVerification && (
        <Button
          fullWidth
          variant="outlined"
          color="primary"
          className={classes.submit}
          style={{ marginTop: 8 }}
          onClick={handleSSOSignIn}
        >
          Sign in with SSO
        </Button>
      )}
    </>
  );
};

// Render MFA verification form
const renderMFAVerification = () => {
  return (
    <div className={classes.verificationContainer}>
      <Typography component="h2" variant="h6" align="center">
        Email Verification
      </Typography>
      
      {message && (
        <div className={classes.messageBox}>
          <Typography variant="body2">{message}</Typography>
        </div>
      )}
      
      <TextField
        variant="outlined"
        margin="normal"
        required
        fullWidth
        id="verificationCode"
        label="Verification Code"
        name="verificationCode"
        autoComplete="off"
        value={code}
        onChange={handleCodeChange}
        autoFocus
      />
      
      <Button
        type="button"
        fullWidth
        variant="contained"
        color="primary"
        onClick={submitEmailCode}
        disabled={isResending}
        className={classes.submit}
      >
        Verify
      </Button>
      
      <Button
        type="button"
        fullWidth
        variant="text"
        color="primary"
        onClick={resendOTP}
        disabled={isResending}
        className={classes.resendButton}
      >
        {isResending ? 'Sending...' : 'Resend Code'}
      </Button>
    </div>
  );
};

  return (
    <div className="App main-layout-background">
      <Header></Header>
      <div className="router-box">
        <Container component="main" maxWidth="xs">
          <div className="mt-5 pt-5">
            <CssBaseline />
            <div className="heading">
              <Avatar className={classes.avatar} style={{ height: '100px', width: 'auto', padding: '0px 10px 0px 0px', margin: '0px', background: '#21518b' }}>
                <LockOpenIcon style={{ height: '3rem', width: '3rem', }} />
              </Avatar>
              {loginShow ? 'Sign in' : 'Sign up'}
            </div>
            <div>
              <img src={mainLogo} width="200" height="200" alt="" className="logo"></img>
            </div>
            <div className={classes.paper}>
              <AgreementDialog open={loginSuccess} />
              <SnackBar open={snackBarStatus.open} message={snackBarStatus.message} />

              <Typography component="h1" variant="h5">
              </Typography>

              {showForgot ? (
                <>
                  <ForgotPassword />
                  <Grid container>
                    <Grid item xs>
                      <Link href="#" variant="body2" onClick={() => setShowForgot(!showForgot)}>
                        {'Back to Login'}
                      </Link>
                    </Grid>
                  </Grid>
                </>
              ) : showMFAVerification ? (
                // Show MFA verification form when needed
                renderMFAVerification()
              ) : (
                // Show regular login form
                <>
                  <form className={classes.form} noValidate onSubmit={login}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      id="email"
                      label="Email Address"
                      name="email"
                      autoComplete="email"
                      value={email}
                      onChange={handleEmailChange}
                      autoFocus
                    />
                    <FormControl className={clsx(classes.textField)} variant="outlined">
                      <InputLabel htmlFor="outlined-adornment-password">Password * </InputLabel>
                      <OutlinedInput
                        fullWidth
                        required
                        id="outlined-adornment-password"
                        type={values.showPassword ? 'text' : 'password'}
                        value={values.password}
                        onChange={handleChange('password')}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {values.showPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        }
                        labelWidth={100}
                      />
                    </FormControl>
                    <Grid container>
                      <Grid item xs>
                        <Checkbox value="remember" color="primary" checked={checkBoxValue} onClick={() => setCheckBoxValue(!checkBoxValue)} />
                        <NavLink to={'/terms'}>I agree with terms and conditions</NavLink>
                      </Grid>
                    </Grid>

                    {renderButtons()}
                    <Grid container>
                      <Grid item xs>
                        <Link href="#" variant="body2" onClick={() => setShowForgot(!showForgot)}>
                          {loginShow ? 'Forgot password?' : ''}
                        </Link>
                      </Grid>
                      <Grid item>
                        <Link href="#" variant="body2" onClick={() => { setLoginShow(!loginShow) }}>
                          {loginShow ? "Don't have an account? Sign Up" : "Go back to Sign In"}
                        </Link>
                      </Grid>
                    </Grid>
                  </form>
                </>
              )}
            </div>
            <Box mt={8}>
              <Copyright />
            </Box>
          </div>
        </Container>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return { isSignedIn: state.auth.isSignedIn };
};

export default connect(mapStateToProps, { signIn, signOut, permssionAssign })(SignIn);
